var map = {
	"./APE.webp": 1168,
	"./BED.webp": 1169,
	"./CNDL.webp": 1170,
	"./CRV.webp": 1171,
	"./DATA.webp": 1172,
	"./DPI.webp": 1173,
	"./GMI.webp": 1174,
	"./GTC.webp": 1175,
	"./LUNC.webp": 1176,
	"./MVI.webp": 1177,
	"./TOKE.webp": 1178,
	"./ZZ.webp": 577,
	"./ZZ_gold.webp": 1179,
	"./rETH.webp": 1180,
	"./wstEth.webp": 1181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1167;